<template>
    <div>TODO</div>
</template>

<script>
export default {
    name: "MainScreen"
}
</script>